<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='Main heading for the customer profile component@@customerOverviewComponent.heading.reminders' class="esf-action-heading__text">Reminders</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                  (click)="createReminder()"
                  [edsTooltip]="tooltipTranslations.i18nCreateNewReminder">
            <svg class="esf-icon" width="16" height="16">
              <use xlink:href="#esf-icon-bell"></use>
            </svg>
          </button>
        </span>
      </span>
    </h1>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="currentReminders"
                         (rowClickEvent)="editReminder($event)"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="setNewReminderList($event)"
                         (actionButtonClickEvent)="createReminder()"

                         [emptyStateText]="tablesTranslations.i18nNoReminder"
                         [emptyStateButtonText]="tablesTranslations.i18nAddNewReminder"
                         [emptyStateIcon]="'#esf-icon-bell-32'">

    </app-paginated-table>

  </div>
</main>
